import { isSafari } from 'react-device-detect';

const pageURL =
  (typeof window !== 'undefined' &&
    `${window.location.href.split('//')[1].split('/')[0]}?metamaskSign`) ||
  '';

const dappURl = isSafari ? 'https://metamask.app.link/dapp/' : 'dapp://';

export const getDAppUrl = () => {
  return `${dappURl}${pageURL}?metamaskSign`;
};
